import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stLine-cloud-upload-l",
  "use": "icon-stLine-cloud-upload-l-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-stLine-cloud-upload-l\"><path d=\"M25 11c-0.4-4.6-4.4-8-9-8s-8.4 3.6-9 8c-3.4 0.4-6 3.4-6 7 0 3.8 3.2 7 7 7h16c3.8 0 7-3.2 7-7 0-3.6-2.6-6.4-6-7zM24 23h-7v-8.6l4.2 4.2 1.4-1.4-6.6-6.6-6.8 6.6 1.4 1.4 4.2-4.2v8.6h-6.8c-2.8 0-5-2.2-5-5s2.2-5 5-5h1v-1c0-3.8 3.2-7 7-7s7 3.2 7 7v1h1c2.8 0 5 2.2 5 5s-2.2 5-5 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/stLine-cloud-upload-l.svg
// module id = Nhtk
// module chunks = 22